import { render, staticRenderFns } from "./AreaStatData.vue?vue&type=template&id=34931d64&scoped=true&"
import script from "./AreaStatData.vue?vue&type=script&lang=js&"
export * from "./AreaStatData.vue?vue&type=script&lang=js&"
import style0 from "./AreaStatData.vue?vue&type=style&index=0&id=34931d64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34931d64",
  null
  
)

export default component.exports